export default "__VITE_ASSET__b919969a__"